import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { ArrowRight } from 'lucide-react';
export const MethodREP = () => {
  return <AnimatedSection className="bg-ink text-paper border-y border-ink" data-id="element-70">
      <div className="mb-16 text-center" data-id="element-71">
        <span className="uppercase tracking-widest text-xs font-semibold text-paper/50 block mb-4" data-id="element-72">
          EL MÉTODO
        </span>
        <h2 className="text-4xl md:text-5xl font-serif" data-id="element-73">
          La clave se llama Método R.E.P.
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-16" data-id="element-74">
        {[{
        letter: 'R',
        title: 'Relevancia',
        desc: 'Conectar con la persona correcta en el momento justo.'
      }, {
        letter: 'E',
        title: 'Empatía',
        desc: 'Entender su problema sin sonar como un robot de ventas.'
      }, {
        letter: 'P',
        title: 'Propuesta',
        desc: 'Ofrecer la llamada como la solución natural a su problema.'
      }].map((item, i) => <div key={i} className="text-center space-y-4 relative" data-id="element-75">
            <div className="text-7xl md:text-8xl font-serif text-accent opacity-90 leading-none" data-id="element-76">
              {item.letter}
            </div>
            <h3 className="text-xl font-serif italic" data-id="element-77">{item.title}</h3>
            {/* <p className="text-sm font-sans text-paper/70">{item.desc}</p> */}
            {i !== 2 && <div className="hidden md:block absolute top-1/2 -right-6 text-paper/20 -translate-y-1/2" data-id="element-78">
                +
              </div>}
          </div>)}
      </div>

      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-79">
        <p className="text-lg md:text-xl font-sans text-paper/80 leading-relaxed" data-id="element-80">
          Es un sistema de conversación de 3 pasos que convierte a un
          desconocido en un chat de Instagram en una cita calificada. No es
          spam, no es molestar a la gente. Es convertirte en el filtro que las
          agencias High Ticket necesitan para escalar.
        </p>

        <div className="bg-paper/5 border border-paper/10 p-6 md:p-8 rounded-sm mt-8" data-id="element-81">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 font-serif text-lg md:text-xl" data-id="element-82">
            <span className="text-paper" data-id="element-83">Vos agendás</span>
            <ArrowRight className="text-accent hidden md:block" data-id="element-84" />
            <span className="text-accent hidden md:inline" data-id="element-85">↓</span>
            <span className="text-paper" data-id="element-86">El vendedor cierra</span>
            <ArrowRight className="text-accent hidden md:block" data-id="element-87" />
            <span className="text-accent hidden md:inline" data-id="element-88">↓</span>
            <span className="text-accent italic" data-id="element-89">
              Vos cobrás comisión en USD
            </span>
          </div>
        </div>
      </div>
    </AnimatedSection>;
};